// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicPriceListControllerCreateData } from './PublicPriceListControllerCreateData.gen';
import type { PublicPriceListControllerCreateErrors } from './PublicPriceListControllerCreateErrors.gen';
import type { PublicPriceListControllerCreatePeriodData } from './PublicPriceListControllerCreatePeriodData.gen';
import type { PublicPriceListControllerCreatePeriodErrors } from './PublicPriceListControllerCreatePeriodErrors.gen';
import type { PublicPriceListControllerCreatePeriodResponses } from './PublicPriceListControllerCreatePeriodResponses.gen';
import type { PublicPriceListControllerCreateResponses } from './PublicPriceListControllerCreateResponses.gen';
import type { PublicPriceListControllerDeleteData } from './PublicPriceListControllerDeleteData.gen';
import type { PublicPriceListControllerDeleteErrors } from './PublicPriceListControllerDeleteErrors.gen';
import type { PublicPriceListControllerDeleteResponses } from './PublicPriceListControllerDeleteResponses.gen';
import type { PublicPriceListControllerGetAllData } from './PublicPriceListControllerGetAllData.gen';
import type { PublicPriceListControllerGetAllErrors } from './PublicPriceListControllerGetAllErrors.gen';
import type { PublicPriceListControllerGetAllResponses } from './PublicPriceListControllerGetAllResponses.gen';
import type { PublicPriceListControllerGetOneData } from './PublicPriceListControllerGetOneData.gen';
import type { PublicPriceListControllerGetOneErrors } from './PublicPriceListControllerGetOneErrors.gen';
import type { PublicPriceListControllerGetOneResponses } from './PublicPriceListControllerGetOneResponses.gen';
import type { PublicPriceListControllerGetPriceListZonesCountData } from './PublicPriceListControllerGetPriceListZonesCountData.gen';
import type { PublicPriceListControllerGetPriceListZonesCountErrors } from './PublicPriceListControllerGetPriceListZonesCountErrors.gen';
import type { PublicPriceListControllerGetPriceListZonesCountResponses } from './PublicPriceListControllerGetPriceListZonesCountResponses.gen';
import type { PublicPriceListControllerGetPriceListZonesData } from './PublicPriceListControllerGetPriceListZonesData.gen';
import type { PublicPriceListControllerGetPriceListZonesErrors } from './PublicPriceListControllerGetPriceListZonesErrors.gen';
import type { PublicPriceListControllerGetPriceListZonesResponses } from './PublicPriceListControllerGetPriceListZonesResponses.gen';
import type { PublicPriceListControllerUpdateData } from './PublicPriceListControllerUpdateData.gen';
import type { PublicPriceListControllerUpdateErrors } from './PublicPriceListControllerUpdateErrors.gen';
import type { PublicPriceListControllerUpdateResponses } from './PublicPriceListControllerUpdateResponses.gen';

export class PublicPriceListController {
    /**
     * Get price list collection.
     *
     * Require: `PERMISSION_PRICE-LISTS_VIEW`
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicPriceListControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicPriceListControllerGetAllResponses, PublicPriceListControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists',
            ...options
        });
    }
    
    /**
     * Create price list name.
     *
     * Require: `PERMISSION_PRICE-LISTS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<PublicPriceListControllerCreateResponses, PublicPriceListControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete price list.
     *
     * If an entity is being used, 409 Conflict will be returned.<br>
     * Require: `PERMISSION_PRICE-LISTS_DELETE`
     */
    public static delete<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<PublicPriceListControllerDeleteResponses, PublicPriceListControllerDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}',
            ...options
        });
    }
    
    /**
     * Get price list by id.
     *
     * Require: `PERMISSION_PRICE-LISTS_VIEW`
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicPriceListControllerGetOneResponses, PublicPriceListControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}',
            ...options
        });
    }
    
    /**
     * Update price list name.
     *
     * Require: `PERMISSION_PRICE-LISTS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<PublicPriceListControllerUpdateResponses, PublicPriceListControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get prices for the given price list.
     *
     * Require: `PERMISSION_PRICE-LISTS_VIEW`
     */
    public static getPriceListZones<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerGetPriceListZonesData, ThrowOnError>) {
        return (options.client ?? client).get<PublicPriceListControllerGetPriceListZonesResponses, PublicPriceListControllerGetPriceListZonesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}/zones',
            ...options
        });
    }
    
    /**
     * Get prices for the given price list.
     *
     * Require: `PERMISSION_PRICE-LISTS_VIEW`
     */
    public static getPriceListZonesCount<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerGetPriceListZonesCountData, ThrowOnError>) {
        return (options.client ?? client).get<PublicPriceListControllerGetPriceListZonesCountResponses, PublicPriceListControllerGetPriceListZonesCountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}/zones-count',
            ...options
        });
    }
    
    /**
     * Create price list period.
     *
     * Zones need to be unique for the given period.<br>
     * Date range cannot overlap within one price list.<br>
     * Require: `PERMISSION_PRICE-LISTS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **DATE_RANGE_IN_COLLISION** - Date range is in collision with another date range.<br>
     * + **INVALID_VALID_TO** - ValidFrom is after ValidTo OR New ValidFrom is null or new validFrom is before old ValidFrom.
     */
    public static createPeriod<ThrowOnError extends boolean = false>(options: Options<PublicPriceListControllerCreatePeriodData, ThrowOnError>) {
        return (options.client ?? client).post<PublicPriceListControllerCreatePeriodResponses, PublicPriceListControllerCreatePeriodErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/price-lists/{id}/periods',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
